import { NOTIFICATION_MODULE_NAME } from "@/store/modules/notification";
import store from '@/store';
import { TNotificationStatus, INotificationItemData } from "@/store/modules/notification/interface";

export default class NotificationCore {

	static ALERT_ACTIVE_TIME: number = 30000;

	static addToast(
		text: string,
		status: TNotificationStatus = 'success',
		showModal: boolean = false
	): Promise<number> {
		return NotificationCore.addToastWithData({ text, status, showModal });
	}

	static addToastWithData(
		v: INotificationItemData,
		activeTimeInMs?: number
	): Promise<number> {
		return store.dispatch(`${NOTIFICATION_MODULE_NAME}/addToast`, v)
			.then(toastId => {
				setTimeout(
					() => NotificationCore.deleteToastById(toastId),
					activeTimeInMs || NotificationCore.ALERT_ACTIVE_TIME
				);

				return toastId;
			});
	}

	static deleteToastById(toastId: number) {
		store.commit(`${NOTIFICATION_MODULE_NAME}/deleteToast`, toastId);
	}

	static clear() {
		store.commit(`${NOTIFICATION_MODULE_NAME}/clearToasts`);
	}

}
